import { createContext, ReactNode } from 'react';

export const NotificationsPopoverCloseContext = createContext<(() => void) | null>(null);

export type NotificationsPopoverCloseProviderProps = {
  onClose: () => void;
  children: ReactNode;
};

/**
 * Provides a close callback for the sidenav notifications popover.
 */
export function NotificationsPopoverCloseProvider({
  onClose,
  children,
}: NotificationsPopoverCloseProviderProps) {
  return (
    <NotificationsPopoverCloseContext.Provider value={onClose}>
      {children}
    </NotificationsPopoverCloseContext.Provider>
  );
}
